module.exports = __webpack_public_path__ + "ARIAL.a78830e85c09c2719966.woff";


//////////////////
// WEBPACK FOOTER
// G:/UTL/Student/Student-ANG/src/assets/fonts/custom/ARIAL.woff
// module id = ../../../../../src/assets/fonts/custom/ARIAL.woff
// module chunks = styles